import React, { useEffect } from "react";
import ComicsHero from "../../images/ComicsHero.png";
import "./Comics.scss";

const Comics: React.FC = (): JSX.Element => {
  const accordion = React.useRef<HTMLDivElement>(null);

  useEffect(() => {
    // @ts-ignore
    $(accordion.current).accordion();
  });

  return (
    <div className="ui Comics">
      <div className="hero">
        <div className="ui container grid">
          <div className="fourteen wide mobile twelve wide tablet twelve wide computer centered column">
            <img className="ui image" src={ComicsHero} />
          </div>
        </div>
      </div>
      <div className="ui container grid">
        <div className="sixteen wide mobile fourteen wide tablet fourteen wide computer centered column">
          <div className="ui segment">
            <h2 className="ui header">
              Introduction
              <div className="sub header">by Jerry Garcia</div>
            </h2>
            <p>
              I‘ve always thought the comics were just a great way to tell a
              story, you know—pictures and words and good ideas.{" "}
              <i>Grateful Dead Comix</i> has been fun and satisfying, although
              in some sense I tend to think of it as a tribute to the EC comics
              we all grew up on.
            </p>
            <div className="ui accordion" ref={accordion}>
              <div className="title">
                <i className="dropdown icon"></i>
                Read entire introduction
              </div>
              <div className="content">
                <p>
                  The first comic that made an impression on me was an EC that
                  my stepfather gave me when I was eight or nine. It was beat
                  up, it didn’t have a cover on it, it was absolutely hideous,
                  really horrible—just perfect. I had asthma as a kid so I got
                  into reading and the way I got into reading was from these
                  comics. I got fascinated by them, by the horribleness of them,
                  for one thing, and by the tongue-in-cheek humor. I found them
                  funny and reasonable and wise, in a kind of Old Testament
                  way—of course, I didn’t know it in those words at that
                  time—but EC comics were always eye for an eye, the bad guy
                  always got it. They were horrible, but they were really well
                  executed, the drawings were excellent and so forth, in fact
                  unparalleled to this day—Wally Wood, Jack Davis, Bill Elder,
                  Harvey Kurtzmann, they even had Frank Frizetta for a little
                  while.{" "}
                  <i>
                    Tales from the Crypt, Vault of Horror, Haunt of Fear, Shock
                    Suspense Stories
                  </i>
                  —I just loved them, and I started collecting them.
                </p>
                <p>
                  Later on in the fifties the comic-regulation deal clamped down
                  heavy on EC. Now, the other thing about EC comic books was
                  that they had a fantastic readership&mdash;the readers were
                  very active; the letters-to-the-editor page was always
                  hilarious; there was this continual row going on between the
                  editors and the readers&mdash;called &ldquo;fanaddicts&rdquo;
                  (fanatics)&mdash;and when the government started persecuting
                  the editors, the readers stuck up tremendously for
                  them&mdash;&ldquo;I&apos;m a schoolteacher and I love these
                  comics... blah blah.&rdquo; It was kind of a heroic effort by
                  a small group of people who loved what they were doing, not
                  unlike the Grateful Dead. The parallels are fairly
                  obvious&mdash;they were dealing with it in the graphic world,
                  but they had their following, like Dead Heads, and they were
                  very devoted to their following, too, they addressed them
                  directly, and they took into account what they said, and so
                  forth. The whole thing had that populist hero kind of quality
                  to it&mdash;the struggling little publishing company taking on
                  the government....
                </p>
                <p>
                  Anyway, they finally hit it big with <i>Mad</i> comics, which
                  turned into <i>Mad</i> magazine, and Bill Gaines is still at
                  it. Most of those guys graduated, some of them went on to
                  tragic ends, and they&rsquo;ve been a running sidebar to my
                  life. And then, of course, when I became a freak, I started to
                  meet all the younger cartoonists who&apos;d been influenced by
                  EC like I was, and they started to put out the underground
                  comics which in a way owed a lot to EC comics except they were
                  like &ldquo;Okay, now let&rsquo;s put out comics the way we
                  want them with absolutely nobody telling us what to do,{" "}
                  <i>completely</i> wide open, you can have anything in
                  them.&rdquo; And that was my second phase of comics&mdash;I
                  was a collector then too, <i>Zap</i>, and so forth.
                </p>
                <p>
                  So <i>Grateful Dead Comix</i> has been the realization of some
                  very old dreams. Our models are the best quality things that
                  are coming out, so we&rsquo;re trying to hang in that top
                  category, in terms of production values, although the artists
                  are on their own&mdash;I wouldn&rsquo;t want to be telling
                  anybody what to write. But presumably they&rsquo;re finding
                  something of value in the songs, and some of them are really
                  powerful stuff, especially &ldquo;Dire Wolf&rdquo; and
                  &ldquo;Cumberland Blues.&rdquo; That&rsquo;s like having
                  something realized in a really nice way&mdash;it scratches the
                  itch. The covers are tremendous, too. The Grateful Dead has
                  always been eclectic stylistically, and so are these comics,
                  going from hard illustrative styles to cartoony, comic-y,
                  bouncy animated stuff. Being able to have that spread of style
                  is fun. I don&rsquo;t know that there&rsquo;s any absolute
                  aesthetic to comics, just like music, and whether or not this
                  material has any interest to anybody besides Dead Heads I
                  couldn&rsquo;t even begin to guess. It doesn&rsquo;t matter,
                  really.
                </p>
                <p>
                  For me, it’s given me new covers to collect, and made me a
                  happy fan. Still a fanaddict after all these years.
                </p>
                <h3 className="ui header">
                  Jerry Garcia
                  <div className="sub header">San Rafael 1991</div>
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Comics;
